<template>
  <BuilderWrapper
    title="Data Filtering"
    helpful-tip="If enabled, this feature allows users to filter the data by location or by category."
  >
    <FilterByLocation :exclude="exclude" />
    <FilterByCategory :exclude="exclude" />
    <FilterDisplaySettings v-if="!exclude.includes('settings')" />
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import FilterByCategory from '@/components/builder/FilterSettings/FilterByCategory.vue'
import FilterByLocation from '@/components/builder/FilterSettings/FilterByLocation.vue'
import FilterDisplaySettings from '@/components/builder/FilterSettings/FilterDisplaySettings.vue'

const components = {
  BuilderWrapper,
  FilterByCategory,
  FilterByLocation,
  FilterDisplaySettings,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class FilterSettings extends Vue.extend({ props }) {}

</script>
